import type { ImageLoaderConfig } from '@/types/image';

export const IMAGE_CONFIG = {
  deviceSizes: [384, 640, 750, 828, 1080, 1200, 1920, 2048, 3840],
  imageSizes: [16, 32, 48, 64, 96, 128, 256, 384],
  defaultQuality: 100,
  defaultFormat: 'webp' as const,
  formats: ['webp', 'jpg', 'png', 'gif', 'avif'] as const,
};

export function glideLoader(config: ImageLoaderConfig): string {
  const baseUrl = import.meta.env.VITE_APP_API;
  const { src, width, height, quality, fit, format } = config;

  const params = new URLSearchParams();
  params.append('src', src);

  if (width) {
    params.append('w', width.toString());
  }

  if (height) {
    params.append('h', height.toString());
  }

  if (quality) {
    params.append('q', quality.toString());
  }

  if (fit) {
    params.append('fit', fit);
  }

  if (format) {
    params.append('fm', format);
  }

  return `${baseUrl}/images/serve?${params.toString()}`;
}
